import React, { Component } from "react";
import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink } from "reactstrap";
import FormModal from "../FormModal"
class EphielNavBar extends Component {

  render() {

    return(
      <div>

        <Navbar fixed-top color="dark" expand="sm">
          
          <NavbarBrand id="navBrand" href="/" >LetMeTakeStep</NavbarBrand>
          <Nav className="mr-auto" navbar>
          </Nav>
          <Nav>
        <NavItem>
          {/* <FormModal /> */}
        </NavItem>
        <NavItem>
          <NavLink href="/Home">Home</NavLink>
        </NavItem>
        <NavItem>
          <NavLink href="/Requests">Requests</NavLink>
        </NavItem>
        <FormModal/>
        </Nav>
        </Navbar>
        

      </div>
    )
  }
}

export default EphielNavBar;